import script from "./CustomField.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomField.vue?vue&type=script&lang=ts&setup=true"

import "./CustomField.vue?vue&type=style&index=0&id=108405c3&lang=less"

const __exports__ = script;

export default __exports__